import { ChangeEventReasonsDataFragment } from "src/components/autoPopulateSelects/ChangeEventReasonsSelectField.generated";
/** Will filter out archived reason records, at least the archived is also in use*/
export function filterArchivedUnlessSelected(
  changeEventReasons?: ChangeEventReasonsDataFragment[],
  inUseId?: string | null,
) {
  return changeEventReasons?.filter((cer) => !cer.archived || cer.id === inUseId) ?? [];
}
